const enterKYCText = `Please fill the KYC details requested by freight forwarder.
  FF will varify all the details shared by you. After verification only,
  FF will approve your invitation.`;

export {
  enterKYCText,
}
